module.exports = __webpack_public_path__ + "img/MrLucas.1ca59db0.png";